/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// Public API for render
export {Renderer2, RendererFactory2} from './render/api';
export {RendererStyleFlags2, RendererType2} from './render/api_flags';
